import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/UI/TextField';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import React from 'react';
import { fade } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: '0px',
    width: '100%',
    minWidth: '150px',
    '& .MuiFilledInput-root': {
      borderRadius: '16px',
      backgroundColor: `${theme.palette.facet.accentBlue20}`,
      height: '50px',
      paddingTop: '0px',
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      backgroundColor: theme.palette.disabledBackground.main,
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.facet.actionActive,
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: fade(theme.palette.error.main, 0.8),
    },
    '& .MuiInputBase-root.Mui-error': {
      color: fade(theme.palette.error.main, 0.8),
      backgroundColor: fade(theme.palette.error.main, 0.3),
      '&:hover': {
        color: fade(theme.palette.error.main, 0.8),
      },
      '& .MuiInputBase-input': {
        color: fade(theme.palette.error.main, 0.8),
      },
      '& .MuiSvgIcon-root': {
        color: fade(theme.palette.error.main, 0.8),
      },
    },
  },
  input: {
    minHeight: '67px', // <--- TODO: Make a const
    color: theme.palette.facet.primaryBlue,
    background: theme.palette.facet.accentBlue20,
    borderRadius: theme.radius.md,
    fontSize: theme.typography.h4.fontSize,
    '&:hover': {
      background: theme.palette.facet.accentBlue20,
    },
  },
}));


function LabellessTextField({
  className, value, onChange, hidden, readonly, label, helperTextValue, helperText, placeholder, onBlur, InputProps, test, ...rest
}) {
  const theme = useTheme();
  const classes = useStyles(theme);


  return (
    <TextField
      value={value}
      onChange={onChange}
      hidden={hidden}
      variant={'filled'}
      disabled={readonly}
      InputProps={{
        disableUnderline: true,
        readonly,
        ...InputProps,
      }}
      HelperProps={{
        showHelperText: false,
      }}
      classes={{
        root: classes.root,
      }}
      placeholder={placeholder}
      hiddenLabel
      onBlur={onBlur}
      size={'small'}
      test={test}
      {...rest}
    />
  );
}

LabellessTextField.propTypes = {
  className: '',
  readonly: 'false',
  hidden: 'false',
  onChange: noop,
  onBlur: noop,
  value: undefined,
  InputProps: {},
  placeholder: '',
  test: '',
  label: '',
  helperText: undefined,
  helperTextValue: '',
};

LabellessTextField.defaultProps = {
  className: PropTypes.string,
  readonly: PropTypes.bool,
  hidden: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  InputProps: PropTypes.object,
  placeholder: PropTypes.string,
  test: PropTypes.string,
  label: PropTypes.string,
  helperTextValue: PropTypes.string,
  helperText: PropTypes.object,
};

export default LabellessTextField;
